export const DEFAULT_ELEMENT_STYLE = Object.freeze({
  fill: "#111111",
  fontSize: 20,
  stroke: "#ff9f43",
  strokeWidth: 2,
});

export const CLICK_SHAPE_SIZE = Object.freeze({ height: 110, width: 180 });
export const CLICK_ARROW_LENGTH = 160;
export const CLICK_DRAG_THRESHOLD_PX = 6;
export const MARQUEE_MIN_SIZE = 4;
export const MIN_FREEHAND_POINT_DISTANCE = 1.5;
export const NUDGE_STEP = Object.freeze({ LARGE: 10, SMALL: 1 });
export const CANVAS_PERSIST_DEBOUNCE_MS = 400;
